(function () {
  // Assortion's cart drawer lists "You may also like" items without the
  // variant name, so a Pack of 2 offer looks like the single pack. Each item's
  // image link carries ?variant=<gid>; look that variant up from
  // /products/<handle>.js and add its name (e.g. "Pack of 2") under the title.
  if (window.__ldCartRecVariant) return;
  window.__ldCartRecVariant = true;

  var ITEM = '.ast-cart__recommendation__vertical-item, .ast-cart__recommendation__horizontal-item';
  var TITLE = '[class*="ast-cart__recommendation__"][class*="__title"]';
  var cache = {};

  var style = document.createElement('style');
  style.textContent =
    '.ld-rec-variant{display:block;margin-top:2px;font-size:12px;line-height:18px;font-weight:500;color:rgb(107,114,128);}';
  document.head.appendChild(style);

  function variantTitles(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          ((p && p.variants) || []).forEach(function (v) { map[String(v.id)] = v.title; });
          return map;
        })
        .catch(function () { return {}; });
    }
    return cache[handle];
  }

  function label(item) {
    var media = item.querySelector('a[href*="variant="]');
    var title = item.querySelector(TITLE);
    if (!media || !title) return;
    var url;
    try { url = new URL(media.getAttribute('href'), location.origin); } catch (e) { return; }
    var vid = (url.searchParams.get('variant') || '').split('/').pop();
    var m = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!vid || !m || item.getAttribute('data-ld-variant') === vid) return;
    item.setAttribute('data-ld-variant', vid);

    variantTitles(m[1]).then(function (map) {
      var name = map[vid];
      var el = item.querySelector('.ld-rec-variant');
      if (!name || name === 'Default Title') { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('span');
        el.className = 'ld-rec-variant';
        title.insertAdjacentElement('afterend', el);
      }
      el.textContent = name;
    });
  }

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll(ITEM).forEach(label);
  }
  new MutationObserver(function () {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
